function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

let subscribers = {};
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

function checkFlexGap() {
  // create flex container with row-gap set
  var flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px";

  // create two, elements inside it
  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div"));

  // append to the DOM (needed to obtain scrollHeight)
  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  flex.parentNode.removeChild(flex);

  return isSupported;
}
if (checkFlexGap()) {
  document.documentElement.classList.add("flexbox-gap");
} else {
  document.documentElement.classList.add("no-flexbox-gap");
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  ).filter((ele) => ele.offsetWidth !== 0 || ele.offsetHeight !== 0);
}

const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  // console.log(elements);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function scrolledCheck() {
  if (window.pageYOffset > 0) {
    document.body.classList.add("window-scrolled");
  } else {
    document.body.classList.remove("window-scrolled");
  }
}
scrolledCheck();
window.addEventListener("scroll", scrolledCheck);

function setHeaderTopPosition() {
  const header = document.getElementById("header");
  if (!header) return;
  const value = header.getBoundingClientRect().top;
  const currentValue = getComputedStyle(
    document.documentElement,
  ).getPropertyValue("--header-top-position");

  if (value && value != currentValue) {
    document.documentElement.style.setProperty(
      "--header-top-position",
      `${value}px`,
    );
  }
}

function setHeaderBottomPosition() {
  const header = document.getElementById("header-wrapper");
  if (!header) return;
  const value = header.getBoundingClientRect().bottom;
  const currentValue = getComputedStyle(
    document.documentElement,
  ).getPropertyValue("--header-bottom-position");

  if (value && value != currentValue) {
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${value}px`,
    );
  }
}

function setPromobarHeight() {
  const promobar = document.getElementById("promobar");
  if (!promobar) return;
  const value = promobar.getBoundingClientRect().height;
  const currentValue = getComputedStyle(
    document.documentElement,
  ).getPropertyValue("--promobar-height");

  if (value && value != currentValue) {
    document.documentElement.style.setProperty(
      "--promobar-height",
      `${value}px`,
    );
  }
}

function setHeaderHeight() {
  const header = document.getElementById("header");
  if (!header) return;
  const value = header.getBoundingClientRect().height;
  const currentValue = getComputedStyle(
    document.documentElement,
  ).getPropertyValue("--header-height");

  if (value && value != currentValue) {
    document.documentElement.style.setProperty("--header-height", `${value}px`);
  }
}

function setCustomPropertiesOnLoad() {
  setPromobarHeight();
  setHeaderHeight();

  setHeaderTopPosition();
  setHeaderBottomPosition();
}

function setCustomPropertiesOnScroll() {
  setPromobarHeight();
  setHeaderHeight();

  setHeaderTopPosition();
  setHeaderBottomPosition();
}

function setCustomPropertiesOnResize() {
  setPromobarHeight();
  setHeaderHeight();

  setHeaderTopPosition();
  setHeaderBottomPosition();
}

window.addEventListener("load", setCustomPropertiesOnLoad, false);

window.addEventListener(
  "scroll",
  debounce(setCustomPropertiesOnScroll, 300),
  false,
);

window.addEventListener(
  "resize",
  debounce(setCustomPropertiesOnResize, 300),
  false,
);

function pauseAllMedia() {
  // document.querySelectorAll(".js-youtube").forEach((video) => {
  //     video.contentWindow.postMessage(
  //         '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
  //         "*"
  //     );
  // });
  // document.querySelectorAll(".js-vimeo").forEach((video) => {
  //     video.contentWindow.postMessage('{"method":"pause"}', "*");
  // });
  // document.querySelectorAll("video").forEach((video) => {
  //     if (video.hasAttribute("control") || video.id.includes("vjs")) {
  //         video.pause();
  //     }
  // });
  // document.querySelectorAll("product-model").forEach((model) => {
  //     if (model.modelViewerUI) model.modelViewerUI.pause();
  // });
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/*
 * Shopify Common JS
 *
 */

document.querySelectorAll("details summary").forEach((summary) => {
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

document.querySelectorAll(".accordion-group").forEach((item) => {
  item.addEventListener("click", function (event) {
    let currentAccordion = event.target.closest(".accordion");
    let currentSummary = event.target.closest(".accordion summary");
    let accordionGroup = event.currentTarget;

    if (!currentSummary) return;
    if (!accordionGroup.contains(currentSummary)) return;

    accordionGroup.querySelectorAll(".accordion").forEach((accordion) => {
      if (accordion != currentAccordion) {
        accordion.removeAttribute("open");
      }
    });
  });
});

class HeaderMega extends HTMLElement {
  constructor() {
    super();

    this.dropdowns = this.querySelectorAll(".header-dropdown");
    this.dropdownToggles = this.querySelectorAll(".header-dropdown-toggle");
    this.dropdownMenus = this.querySelectorAll(".header-dropdown-menu");

    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("keyup", this.onKeyUp.bind(this));

    this.dropdownToggles.forEach((item) => {
      item.addEventListener("click", this.onDropdownToggleClick.bind(this));
    });

    this.dropdowns.forEach((item) => {
      item.addEventListener("focusout", this.onDropdownFocusOut.bind(this));
      item.addEventListener("mouseenter", this.onDropdownMouseEnter.bind(this));
      item.addEventListener("mouseleave", this.onDropdownMouseLeave.bind(this));
    });

    this.dropdownMenus.forEach((item) => {
      item.addEventListener("mouseleave", this.onDropdownMouseLeave.bind(this));
    });
  }

  onDropdownToggleClick(event) {
    event.preventDefault();

    const dropdownToggle = event.currentTarget;
    const dropdown = dropdownToggle.parentNode;

    if (this.isDropdownOpen(dropdown)) {
      this.closeDropdown(dropdown);
      this.closeMega();
    } else {
      this.openDropdown(dropdown);
      this.openMega();
    }
  }

  onDropdownMouseEnter(event) {
    const dropdown = event.currentTarget;

    if (this.hasDropdownOpen()) {
      if (this.isDropdownClose(dropdown)) {
        this.openTimer = setTimeout(() => {
          if (this.closeTimer) {
            clearTimeout(this.closeTimer);
          }
          this.closeAllDropdowns();
          this.openDropdown(dropdown);
        }, 100);
      } else {
        if (this.closeTimer) {
          clearTimeout(this.closeTimer);
        }
        if (this.openTimer) {
          clearTimeout(this.openTimer);
        }
      }
    } else {
      this.openDropdown(dropdown);
      this.openMega();
    }
  }

  onDropdownMouseLeave(event) {
    const dropdown = event.currentTarget;

    if (this.isDropdownOpen(dropdown)) {
      this.closeTimer = setTimeout(() => {
        this.closeDropdown(dropdown);
        this.closeMega();
      }, 200);
    }
  }

  onDropdownFocusOut(event) {
    if (
      !(event.relatedTarget && event.relatedTarget.closest(".header-wrapper"))
    ) {
      if (this.hasDropdownOpen()) {
        this.closeAllDropdowns();
        this.closeMega();
      }
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    this.closeDropdown(openDetailsElement);
    this.closeMega();
  }

  isDropdownOpen(detailsElement) {
    return (
      detailsElement.hasAttribute("open") &&
      detailsElement.classList.contains("open")
    );
  }

  isDropdownClose(detailsElement) {
    return !detailsElement.hasAttribute("open");
  }

  hasDropdownOpen() {
    return this.classList.contains("dropdown-open");
  }

  openDropdown(detailsElement) {
    const summaryElement = detailsElement.querySelector("summary");

    // close all sub drawers
    this.closeAllDropdowns();

    detailsElement.setAttribute("open", "");
    detailsElement.classList.add("open");
    summaryElement.setAttribute("aria-expanded", true);

    // update status
    this.classList.add("dropdown-open");

    // trap focus
    trapFocus(detailsElement, summaryElement);
  }

  closeDropdown(detailsElement) {
    const summaryElement = detailsElement.querySelector("summary");

    detailsElement.removeAttribute("open");
    detailsElement.classList.remove("open");

    summaryElement.setAttribute("aria-expanded", false);

    // remove trap focus
    removeTrapFocus(summaryElement);

    // close sub drawer animation

    // update status
    this.classList.remove("dropdown-open");
  }

  closeAllDropdowns() {
    this.dropdowns.forEach((item) => {
      if (this.isDropdownOpen(item)) {
        this.closeDropdown(item);
      }
    });
  }

  openMega() {
    document.body.classList.add("header-mega-open", "overflow-hidden");
  }

  closeMega() {
    document.body.classList.remove("header-mega-open", "overflow-hidden");
  }
}
customElements.define("header-mega", HeaderMega);

class HeaderDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawerContainer = this.querySelector(".header-drawer-container");
    this.drawerToggle = this.drawerContainer.querySelector(
      ".header-drawer-toggle",
    );
    this.drawerCloseButton = this.drawerContainer.querySelector(
      ".header-drawer-close",
    );
    this.drawer = this.drawerContainer.querySelector(".header-drawer");
    this.drawerLink = this.drawerContainer.querySelectorAll(
      ".header-drawer-menu-link",
    );

    this.subDrawerContainers = this.drawerContainer.querySelectorAll(
      ".header-subdrawer-container",
    );
    this.subDrawerToggles = this.drawerContainer.querySelectorAll(
      ".header-subdrawer-toggle",
    );

    this.subDrawerCloseButtons = this.drawerContainer.querySelectorAll(
      ".header-subdrawer-close",
    );
    this.subDrawers =
      this.drawerContainer.querySelectorAll(".header-subdrawer");

    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onDrawerFocusOut.bind(this));

    this.drawerToggle.addEventListener(
      "click",
      this.onDrawerToggleClick.bind(this),
    );
    this.drawerCloseButton.addEventListener(
      "click",
      this.onDrawerCloseButtonClick.bind(this),
    );

    this.subDrawerToggles.forEach((item) => {
      item.addEventListener("click", this.onSubDrawerToggleClick.bind(this));
    });

    this.subDrawerCloseButtons.forEach((item) => {
      item.addEventListener(
        "click",
        this.onSubDrawerCloseButtonClick.bind(this),
      );
    });

    this.subDrawerContainers.forEach((item) => {
      item.addEventListener("focusout", this.onSubDrawerFocusOut.bind(this));
    });
  }

  onDrawerToggleClick(event) {
    event.preventDefault();

    if (this.isDrawerOpen()) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  }

  onDrawerCloseButtonClick(event) {
    event.preventDefault();
    this.closeDrawer();
  }

  onSubDrawerToggleClick(event) {
    event.preventDefault();

    const subDrawerToggle = event.currentTarget;
    const subDrawerContainer = subDrawerToggle.parentNode;

    if (this.isSubDrawerOpen(subDrawerContainer)) {
      this.closeSubDrawer(subDrawerContainer);
    } else {
      this.openSubDrawer(subDrawerContainer);
    }
  }

  onSubDrawerCloseButtonClick(event) {
    event.preventDefault();

    const detailsElement = event.currentTarget.closest("details");
    this.closeSubDrawer(detailsElement);
  }

  onDrawerFocusOut(event) {
    const relatedTarget = event.relatedTarget;
    setTimeout(() => {
      if (this.isDrawerOpen() && !this.drawerContainer.contains(relatedTarget))
        this.closeDrawer();
    });
  }

  onSubDrawerFocusOut(event) {
    const subDrawerContainer = event.currentTarget;
    const relatedTarget = event.relatedTarget;
    setTimeout(() => {
      if (this.hasSubDrawerOpen() && relatedTarget === this.drawer)
        this.closeSubDrawer(subDrawerContainer);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    if (openDetailsElement === this.drawerContainer) {
      this.closeDrawer(this.drawerToggle);
    } else {
      this.closeSubDrawer(openDetailsElement);
    }
  }

  isDrawerOpen() {
    return (
      this.drawerContainer.hasAttribute("open") &&
      this.drawerContainer.classList.contains("open")
    );
  }

  isSubDrawerOpen(detailsElement) {
    return (
      detailsElement.hasAttribute("open") &&
      detailsElement.classList.contains("open")
    );
  }

  isSubDrawerClose(detailsElement) {
    return !detailsElement.hasAttribute("open");
  }

  hasSubDrawerOpen() {
    return this.drawerContainer.classList.contains("subdrawer-open");
  }

  openDrawer() {
    // open drawer
    setTimeout(() => {
      this.drawerContainer.setAttribute("open", "");
      this.drawerToggle.setAttribute("aria-expanded", true);
    });

    // trap focus
    trapFocus(this.drawerContainer, this.drawerToggle);

    // update status
    document.body.classList.add("header-drawer-open", "overflow-hidden");
  }

  openSubDrawer(detailsElement) {
    const summaryElement = detailsElement.querySelector("summary");

    // close all sub drawers
    this.closeAllSubDrawers();

    // open sub drawer
    setTimeout(() => {
      detailsElement.setAttribute("open", "");
      summaryElement.setAttribute("aria-expanded", true);
    });

    // trap focus
    trapFocus(detailsElement, summaryElement);

    // update status
    this.drawerContainer.classList.add("subdrawer-open");
  }

  closeDrawer(elementToFocus = false) {
    // remove trap focus
    removeTrapFocus(elementToFocus);

    // close drawer
    this.drawerContainer.removeAttribute("open");
    this.drawerToggle.setAttribute("aria-expanded", false);

    // close all sub drawers
    this.closeAllSubDrawers();

    // update status
    document.body.classList.remove("header-drawer-open", "overflow-hidden");
  }

  closeSubDrawer(detailsElement) {
    const summaryElement = detailsElement.querySelector("summary");
    const menuElement = summaryElement.nextElementSibling;

    // remove trap focus
    removeTrapFocus(summaryElement);

    // close sub drawer

    detailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);

    // update status
    this.drawerContainer.classList.remove("subdrawer-open");
  }

  closeAllSubDrawers() {
    this.subDrawerContainers.forEach((item) => {
      if (this.isSubDrawerOpen(item)) {
        this.closeSubDrawer(item);
      }
    });
  }
}
customElements.define("header-drawer", HeaderDrawer);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define("menu-drawer", MenuDrawer);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.querySelector('[role="dialog"]').classList.add("active");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    if (
      this.querySelector('[role="dialog"]').classList.contains(
        "modal-dialog--animation",
      )
    ) {
      this.querySelector('[role="dialog"]').addEventListener(
        "transitionend",
        () => {
          document.body.classList.remove("overflow-hidden");
          document.body.dispatchEvent(new CustomEvent("modalClosed"));
          this.removeAttribute("open");
          removeTrapFocus(this.openedBy);
          window.pauseAllMedia();
        },
        { once: true },
      );

      this.querySelector('[role="dialog"]').classList.remove("active");
    } else {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
      this.querySelector('[role="dialog"]').classList.remove("active");
      this.removeAttribute("open");
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }
  }
}
customElements.define("modal-dialog", ModalDialog);

class NewsletterModal extends ModalDialog {
  constructor() {
    super();

    this.initialDelay = 0;
    this.idleTime = 0;

    if (!Cookies.get("newsletter_modal")) {
      this.init();
    }
  }

  init() {
    document.addEventListener("mousemove", function (e) {
      this.idleTime = 0;
    });
    document.addEventListener("keydown", function (e) {
      this.idleTime = 0;
    });

    this.initialDelayInterval = setInterval(
      this.timerIncrement.bind(this),
      1000,
    );

    this.idleTimeInterval = setInterval(this.timerIncrement.bind(this), 1000);
  }

  isOverflowHidden() {
    return getComputedStyle(document.documentElement).overflow == "hidden" ||
      getComputedStyle(document.body).overflow == "hidden"
      ? true
      : false;
  }

  timerIncrement() {
    this.initialDelay = this.initialDelay + 1;
    this.idleTime = this.idleTime + 1;
    this.tryOpenPopup();
  }

  tryOpenPopup() {
    if (
      this.initialDelay >= 20 &&
      this.idleTime >= 3 &&
      !this.isOverflowHidden()
    ) {
      this.show();

      Cookies.set("newsletter_modal", "true", {
        expires: 7,
      });

      clearInterval(this.initialDelayInterval);
      clearInterval(this.idleTimeInterval);
    }
  }
}
customElements.define("newsletter-modal", NewsletterModal);

class CookieModal extends ModalDialog {
  constructor() {
    super();

    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      function (error) {
        if (error) {
          throw error;
        }
        this.initCookieBanner();
      }.bind(this),
    );

    this.cookieAcceptButton = this.querySelector(".cookie-modal-cta--accept");
    this.cookieCloseButton = this.querySelector(".cookie-modal-cta--close");
    this.modalCloseButton = this.querySelector(".modal-close");

    this.bindEvents();
  }

  bindEvents() {
    this.cookieAcceptButton.addEventListener(
      "click",
      this.handleAccept.bind(this),
    );
    this.cookieCloseButton.addEventListener("click", this.hide.bind(this));
    this.modalCloseButton.addEventListener(
      "click",
      this.handleAccept.bind(this),
    );

    this.removeEventListener("click", this.onModalClickBound);
  }

  handleAccept() {
    window.Shopify.customerPrivacy.setTrackingConsent(
      true,
      this.hide.bind(this),
    );

    document.addEventListener("trackingConsentAccepted", function () {
      // console.log('trackingConsentAccepted event fired');
    });
  }

  handleDecline() {
    window.Shopify.customerPrivacy.setTrackingConsent(
      false,
      this.hide.bind(this),
    );
  }

  initCookieBanner() {
    if (window.Shopify.customerPrivacy.shouldShowGDPRBanner()) {
      this.show();
    }
  }
}
customElements.define("cookie-modal", CookieModal);

class GeolocationModal extends ModalDialog {
  constructor() {
    super();

    this.countryList = JSON.parse(
      document.querySelector("#geolocation-modal-data").textContent,
    );
    this.currentStoreCountryISO = window.Shopify.country;

    this.detectionCountryNameEle = document.querySelector(
      "#geolocation-modal-detection-country-name",
    );
    this.detectionMessageEle = document.querySelector(
      ".geolocation-modal-detection-message",
    );
    this.detectionLinkEleList = document.querySelectorAll(
      ".geolocation-modal-detection-link",
    );
    this.storeItemEleList = document.querySelectorAll(
      ".geolocation-modal-store-disclosure-menu-item",
    );

    if (!Cookies.get("geolocation_modal")) {
      navigator.geolocation.getCurrentPosition(
        this.geoSuccess.bind(this),
        this.geoError.bind(this),
      );
    }
  }

  geoSuccess(position) {
    this.getDetectionCountry().then(this.update.bind(this));
  }

  geoError(error) {
    console.warn(`ERROR(${error.code}): ${error.message}`);
  }

  async getDetectionCountry() {
    const response = await fetch(
      window.Shopify.routes.root +
        "browsing_context_suggestions.json" +
        "?country[enabled]=true",
    ).then((response) => response.json());

    return response;
  }

  update(response) {
    const detectedCountryISO = response.detected_values.country.handle;
    const detectedCountryName = response.detected_values.country.name;

    this.updateDetectedCountryName(detectedCountryName);
    this.showDetectedCountryName();

    if (this.hasMatchedStore(detectedCountryISO)) {
      this.updateDetectedLink(detectedCountryISO);
      this.updateStoreList(detectedCountryISO);
    } else {
      this.updateDetectedLink(this.currentStoreCountryISO);
      this.showNoMatchedStoreMessage();
    }

    this.setCookie();

    if (detectedCountryISO != this.currentStoreCountryISO) {
      this.show();
    }
  }

  hasMatchedStore(countryISO) {
    return this.countryList.countries.some((country) => {
      return country.iso_code == countryISO;
    });
  }

  showNoMatchedStoreMessage() {
    this.detectionMessageEle.classList.remove("hidden");
  }

  updateDetectedCountryName(countryName) {
    this.detectionCountryNameEle.innerHTML = countryName;
  }

  showDetectedCountryName() {
    this.detectionCountryNameEle.classList.remove("visibility-hidden");
  }

  updateDetectedLink(countryISO) {
    const results = Array.from(this.detectionLinkEleList).filter(
      (item) => item.dataset.isoCode !== countryISO,
    );

    results.forEach((item) => item.remove());
  }

  updateStoreList(countryISO) {
    const results = Array.from(this.storeItemEleList).filter(
      (item) => item.dataset.isoCode == countryISO,
    );

    results.forEach((item) => item.remove());
  }

  setCookie() {
    Cookies.set("geolocation_modal", "true", {
      expires: 30,
    });
  }
}
customElements.define("geolocation-modal", GeolocationModal);

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter"),
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID),
        );

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains("mobile-facets__details")
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden"),
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item"),
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form"),
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    this.announce(event.target.dataset.accessibility);
    FacetFiltersForm.renderPage(url);
  }

  announce(message) {
    const region = document.getElementById("aria-live-region");
    if (region) {
      region.textContent = message;
      setTimeout(() => {
        region.textContent = "";
      }, 1000);
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

class FilterDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (event) => event.code === "Escape" && this.close(),
    );

    this.addEventListener("click", this.onModalClick.bind(this));

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#FilterDrawer-open");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  onModalClick(event) {
    if (event.target === this) this.close();
    if (event.target.closest("#FilterDrawer-Close")) this.close();
    if (event.target.closest("#FilterDrawer-Apply")) this.close();
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.openBy = opener;
    this.setAttribute("open", "");
    trapFocus(this, this.querySelector('[role="dialog"]'));
    document.body.classList.add("filter-drawer-opening", "overflow-hidden");
  }

  close() {
    removeTrapFocus(this.openBy);
    this.removeAttribute("open");
    document.body.classList.remove("filter-drawer-opening", "overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("filter-drawer", FilterDrawer);

class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".product-gallery-slider");
    this.thumbSlider = this.querySelector(".product-gallery-thumbSlider");
    this.script = this.querySelector('[type="application/json"]');
    this.variantDefaultData = this.getDefaultVariantData();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.loadContent(this.variantDefaultData, this.thumbSlider);
    this.loadContent(this.variantDefaultData, this.slider);
    this.initThumbSlider();
    this.initSlider();
  }

  refresh(variantData) {
    if (this.thumbSwiper) {
      this.destroySlider(this.thumbSwiper);
    }
    if (this.sliderSwiper) {
      this.destroySlider(this.sliderSwiper);
    }
    this.loadContent(variantData, this.thumbSlider);
    this.loadContent(variantData, this.slider);
    this.initThumbSlider();
    this.initSlider();
  }

  getDefaultVariantData() {
    return JSON.parse(this.script.textContent);
  }

  loadContent(variantData, slider) {
    this.template = slider.querySelector("template");
    const variantID = variantData.id;
    const templateContent = this.template.content.cloneNode(true);
    const target = slider.querySelector(".swiper-wrapper");
    target.innerHTML = "";
    target.append(templateContent);
    Array.from(target.children).forEach(function (item) {
      if (item.dataset.variantId != variantID) {
        item.remove();
      }
    });
  }

  initThumbSlider() {
    this.thumbSwiper = new Swiper(this.thumbSlider, {
      direction: "vertical",
      slidesPerView: "auto",
      spaceBetween: 5,
      freeMode: true,
      watchSlidesProgress: true,

      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
    });
  }

  initSlider() {
    this.sliderSwiper = new Swiper(this.slider, {
      loop: true,
      speed: 400,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
      },
      focusableElements: ".focusDisableSwiper",
      navigation: {
        prevEl: this.slider.querySelector(".swiper-nav-button--prev"),
        nextEl: this.slider.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        type: "bullets",
        bulletClass: "swiper-pagination-bullet--line",
        bulletActiveClass: "active",
      },
      thumbs: {
        swiper: this.thumbSwiper,
      },
      on: {
        init: function (swiper) {
          // On first load — set aria-hidden
          swiper.slides.forEach((slide, index) => {
            if (index === swiper.activeIndex) {
              slide.setAttribute("aria-hidden", "false");
            } else {
              slide.setAttribute("aria-hidden", "true");
            }
          });
        },
        activeIndexChange: function (swiper) {
          const currentSlideVideo =
            swiper.slides[swiper.activeIndex].querySelector("video");
          const previousSlideVideo =
            swiper.slides[swiper.previousIndex].querySelector("video");
          if (previousSlideVideo) {
            previousSlideVideo.pause();
          }
          if (currentSlideVideo) {
            currentSlideVideo.play();
          }

          swiper.slides.forEach((slide, index) => {
            if (index === swiper.activeIndex) {
              slide.setAttribute("aria-hidden", "false");
            } else {
              slide.setAttribute("aria-hidden", "true");
            }
          });
        },
      },
    });
  }

  destroySlider(swiper) {
    swiper.destroy(true, true);
  }
}
customElements.define("product-gallery", ProductGallery);

class ProductComplementary extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const complementary = html.querySelector("product-complementary");

        if (complementary && complementary.innerHTML.trim().length) {
          this.innerHTML = complementary.innerHTML;
        }

        this.carousel = this.querySelector(".swiper");

        this.swiper = new Swiper(this.carousel, {
          loop: false,
          grabCursor: true,
          slidesPerView: 2.2,
          spaceBetween: 2,
          centerInsufficientSlides: true,
          mousewheel: {
            forceToAxis: true,
          },
          freeMode: {
            enabled: true,
            sticky: false,
          },
          navigation: {
            prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
            nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
            disabledClass: "hidden",
          },
          breakpoints: {
            768: {
              slidesPerView: 3.2,
            },
            992: {
              slidesPerView: 3.2,
            },
            1200: {
              slidesPerView: 4.2,
            },
          },
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("product-complementary", ProductComplementary);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.carousel = this.querySelector(".swiper");

        this.swiper = new Swiper(this.carousel, {
          loop: false,
          grabCursor: true,
          slidesPerView: 2.2,
          spaceBetween: 2,
          centerInsufficientSlides: true,
          mousewheel: {
            forceToAxis: true,
          },
          freeMode: {
            enabled: true,
            sticky: false,
          },
          navigation: {
            prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
            nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
            disabledClass: "hidden",
          },
          breakpoints: {
            768: {
              slidesPerView: 3.2,
            },
            992: {
              slidesPerView: 3.2,
            },
            1200: {
              slidesPerView: 4.2,
            },
          },
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close(),
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this),
    );
    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this),
    );

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
  }
}
customElements.define("details-modal", DetailsModal);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.details.querySelector("summary");
    this.content = this.summary.nextElementSibling;

    this.details.addEventListener("focusout", this.onFocusOut.bind(this));
    this.summary.addEventListener("click", this.onToggle.bind(this));
    this.details.addEventListener("mouseenter", this.onMouseEnter.bind(this));
    this.details.addEventListener("mouseleave", this.onMouseLeave.bind(this));
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onMouseEnter(event) {
    this.openTimer = setTimeout(() => {
      this.open();
    }, 200);
  }

  onMouseLeave(event) {
    if (this.openTimer) {
      clearTimeout(this.openTimer);
    }
    this.close();
  }

  onToggle(event) {
    event.preventDefault();
    if (this.details.open) {
      this.close();
    } else {
      this.open();
    }
  }

  open(event) {
    this.details.setAttribute("open", true);
    this.details.querySelector("summary").setAttribute("aria-expanded", true);
  }

  close(event) {
    this.details.removeAttribute("open");
    this.details.querySelector("summary").setAttribute("aria-expanded", false);
  }
}
customElements.define("details-disclosure", DetailsDisclosure);

class PromoBar extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector(".swiper");
    this.sliderSpeed = this.slider.dataset.speed;
    this.sliderAutoplay = this.slider.dataset.autoplay === "true";
    this.sliderPauseOnHover = this.slider.dataset.pauseOnHover === "true";
  }
  connectedCallback() {
    this.swiper = new Swiper(this.slider, {
      loop: true,
      speed: 600,
      allowTouchMove: false,
      followFinger: false,
      simulateTouch: false,
      effect: "fade",
      navigation: {
        prevEl: this.slider.querySelector(".swiper-nav-button--prev"),
        nextEl: this.slider.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      fadeEffect: {
        crossFade: true,
      },
      autoplay: this.sliderAutoplay
        ? {
            delay: this.sliderSpeed,
            pauseOnMouseEnter: this.sliderPauseOnHover,
            disableOnInteraction: false,
          }
        : false,
    });
  }
}
customElements.define("promo-bar", PromoBar);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.links = this.form.querySelectorAll("a");
    this.input = this.form.querySelector(
      'input[name="locale_code"], input[name="country_code"]',
    );

    this.links.forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this)),
    );
  }

  onItemClick(event) {
    event.preventDefault();
    this.input.value = event.currentTarget.dataset.value;
    if (this.form) this.form.submit();
  }
}
customElements.define("localization-form", LocalizationForm);

class HomePageSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector(".swiper");

    this.sliderAutoplayEnable =
      this.slider.dataset.sliderAutoplayEnable === "true";
    this.sliderAutoplayInterval = this.slider.dataset.sliderAutoplayInterval;
  }
  connectedCallback() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 400,
      grabCursor: true,
      autoplay: this.sliderAutoplayEnable
        ? {
            delay: this.sliderAutoplayInterval,
            pauseOnMouseEnter: false,
            disableOnInteraction: true,
          }
        : false,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        prevEl: this.slider.querySelector(".swiper-nav-button--prev"),
        nextEl: this.slider.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        type: "custom",
        renderCustom: function (swiper, current, total) {
          return current + " | " + total;
        },
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
      on: {
        slideChangeTransitionStart: function (swiper, speed, internal) {
          // get the control color of the next slide
          const activeSlide = swiper.slides[swiper.activeIndex];
          const activeSlideControlColor =
            activeSlide.dataset.sliderControlColor;
          // spread the control color to slider
          swiper.el.style.setProperty(
            "--swiper-theme-color",
            activeSlideControlColor,
          );
          swiper.el.style.setProperty(
            "--swiper-navigation-color",
            activeSlideControlColor,
          );
        },
      },
    });
  }
}
customElements.define("homepage-slider", HomePageSlider);

class HomePageTestimonialsCarousel extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector(".hp-testimonials-carousel");
    this.backgroundSlider = this.querySelector(".swiper-background");
    this.contentSlider = this.querySelector(".swiper-content");

    this.sliderAutoplayEnable =
      this.container?.dataset.sliderAutoplayEnable === "true";
    this.sliderAutoplayInterval =
      this.container?.dataset.sliderAutoplayInterval;
  }

  connectedCallback() {
    this.backgroundSwiper = new Swiper(this.backgroundSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 300,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      allowTouchMove: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        thresholdDelta: 10,
        thresholdTime: 500,
        releaseOnEdges: true,
      },
    });

    this.contentSwiper = new Swiper(this.contentSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 300,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      grabCursor: true,
      autoplay: this.sliderAutoplayEnable
        ? {
            delay: this.sliderAutoplayInterval,
            pauseOnMouseEnter: false,
            disableOnInteraction: true,
          }
        : false,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        thresholdDelta: 10,
        thresholdTime: 500,
        releaseOnEdges: true,
      },
      navigation: {
        prevEl: this.querySelector(".swiper-nav-button--prev"),
        nextEl: this.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
      controller: {
        control: this.backgroundSwiper,
      },
      on: {
        slideChangeTransitionStart: (swiper) => {
          const activeSlide = swiper.slides[swiper.activeIndex];
          const activeSlideControlColor =
            activeSlide?.dataset.sliderControlColor;

          if (activeSlideControlColor) {
            this.container.style.setProperty(
              "--swiper-theme-color",
              activeSlideControlColor,
            );
            this.container.style.setProperty(
              "--swiper-navigation-color",
              activeSlideControlColor,
            );
          }
        },
      },
    });

    this.backgroundSwiper.controller.control = this.contentSwiper;
  }
}

customElements.define(
  "homepage-testimonials-carousel",
  HomePageTestimonialsCarousel,
);


class HomePageBlogsCarousel extends HTMLElement {
  constructor() {
    super();

    this.slider_top = this.querySelector(".hp-blogs-carousel:not(.hp-blogs-carousel--side) .swiper");
    this.slider_side = this.querySelector(".hp-blogs-carousel.hp-blogs-carousel--side .swiper");
  }

  connectedCallback() {
    this.slider_top = new Swiper(this.slider_top, {
      slidesPerView: 2.1,
      spaceBetween: 2,
      loop: true,
      speed: 300,
      allowTouchMove: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        thresholdDelta: 10,
        thresholdTime: 500,
        releaseOnEdges: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        }
      },
    });

    this.slider_side = new Swiper(this.slider_side, {
      slidesPerView: 'auto',
      spaceBetween: 2,
      loop: false,
      speed: 300,
      allowTouchMove: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        thresholdDelta: 10,
        thresholdTime: 500,
        releaseOnEdges: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        }
      },
    });
  }
}

customElements.define(
  "homepage-blogs-carousel",
  HomePageBlogsCarousel,
);

class HomePageProductCarousel extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".swiper");
  }
  connectedCallback() {
    this.swiper = new Swiper(this.carousel, {
      grabCursor: true,
      slidesPerView: 2.2,
      spaceBetween: 2,
      centerInsufficientSlides: false,
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: true,
        sticky: false,
      },
      navigation: {
        prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
        nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        992: {
          slidesPerView: 3.2,
        },
        1200: {
          slidesPerView: 4.2,
        },
      },
    });
  }
}
customElements.define("homepage-product-carousel", HomePageProductCarousel);

class HomePageCategoryCarousel extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".swiper");
    this.totalSlides = parseInt(this.carousel.dataset.totalSlides, 10);
  }
  connectedCallback() {
    this.swiper = new Swiper(this.carousel, {
      grabCursor: true,
      slidesPerView: 2.1,
      spaceBetween: 2,
      centerInsufficientSlides: false,
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: true,
        sticky: false,
      },
      navigation: {
        prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
        nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      breakpoints: {
        768: {
          slidesPerView: 2.1,
        },
        992: {
          slidesPerView: 3.1,
        },
        1200: {
          slidesPerView: this.totalSlides >= 5 ? 5 : this.totalSlides,
        },
      },
    });
  }
}
customElements.define("homepage-category-carousel", HomePageCategoryCarousel);

class productpageIngredientCarousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        prevEl: this.querySelector(".swiper-nav-button--prev"),
        nextEl: this.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
    });
  }
}
customElements.define(
  "productpage-ingredient-carousel",
  productpageIngredientCarousel,
);


class ProductpageCustomTabbedCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper       = null;
    this._touchStartX = 0;
    this._touchEndX   = 0;
    this._MIN_SWIPE   = 40;

    this._onSlideChange  = this._onSlideChange.bind(this);
    this._onTouchStart   = this._onTouchStart.bind(this);
    this._onTouchEnd     = this._onTouchEnd.bind(this);
  }

  connectedCallback() {
    // Scoped queries — no document.querySelector, no ambiguity across instances
    this._tabs        = Array.from(this.querySelectorAll('.ctm-tab'));
    this._desktopDots = Array.from(this.querySelectorAll('#DotsDesktop-' + this._blockId() + ' .ctm-dot'));
    this._mobileDots  = Array.from(this.querySelectorAll('#DotsMobile-'  + this._blockId() + ' .ctm-dot'));
    this._contentCol  = this.querySelector('.ctm-content-col');

    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) return;
    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: slideCount === 1 ? 1 : 1.06,
      spaceBetween: 0,
      grabCursor: true,
      // centeredSlides: true,
      mousewheel: { forceToAxis: true },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
      speed: 500,
      breakpoints: {
        992: {
          slidesPerView: 1,
        }
      },
      on: {
        slideChange: this._onSlideChange,
      },
    });

    this._bindTabs();
    this._bindDots();
    this._bindTouchSwipe();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    if (this._contentCol) {
      this._contentCol.removeEventListener('touchstart', this._onTouchStart);
      this._contentCol.removeEventListener('touchend',   this._onTouchEnd);
    }
  }

  _blockId() {
    // Derives block ID from the element's own ID: "pdpCustomTabModule-XXXX" → "XXXX"
    return this.id.replace('pdpCustomTabModule-', '');
  }

  goToSlide(index) {
    if (this.swiper) this.swiper.slideTo(index);
  }

  _syncActiveState(currentIndex) {
    this._tabs.forEach((tab, i) => {
      const isActive = i === currentIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    [this._desktopDots, this._mobileDots].forEach((dotSet) => {
      dotSet.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    });
  }

  _onSlideChange() {
    console.log('slide changed to', this.swiper.activeIndex);
    this._syncActiveState(this.swiper.activeIndex);
  }

  _bindTabs() {
    this._tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.goToSlide(parseInt(tab.dataset.index, 10));
      });

      tab.addEventListener('keydown', (e) => {
        // Arrow key navigation between tabs (ARIA tablist pattern)
        let next = parseInt(tab.dataset.index, 10);

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          next = (next + 1) % this._tabs.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          next = (next - 1 + this._tabs.length) % this._tabs.length;
        } else if (e.key === 'Home') {
          next = 0;
        } else if (e.key === 'End') {
          next = this._tabs.length - 1;
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.goToSlide(next);
          return;
        } else {
          return;
        }

        e.preventDefault();
        this.goToSlide(next);
        this._tabs[next].focus();
      });
    });
  }

  _bindDots() {
    [this._desktopDots, this._mobileDots].forEach((dotSet) => {
      dotSet.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goToSlide(parseInt(dot.dataset.index, 10));
        });
      });
    });
  }

  _bindTouchSwipe() {
    if (!this._contentCol) return;

    this._contentCol.addEventListener('touchstart', this._onTouchStart, { passive: true });
    this._contentCol.addEventListener('touchend',   this._onTouchEnd,   { passive: true });
  }

  _onTouchStart(e) {
    this._touchStartX = e.changedTouches[0].screenX;
  }

  _onTouchEnd(e) {
    this._touchEndX = e.changedTouches[0].screenX;
    this._handleTextSwipe();
  }

  _handleTextSwipe() {
    if (window.innerWidth >= 992) return; // desktop: Swiper handles its own drag

    const distance = this._touchStartX - this._touchEndX;

    if (distance > this._MIN_SWIPE) {
      this.swiper.slideNext();
    } else if (distance < -this._MIN_SWIPE) {
      this.swiper.slidePrev();
    }
  }
}

customElements.define('productpage-custom-tabbed-carousel', ProductpageCustomTabbedCarousel);



class ProductpageCompareProductsCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper      = null;
    this._BREAKPOINT = 992;

    this._onResize      = this._onResize.bind(this);
    this._onImageLoad   = this._onImageLoad.bind(this);
    this._resizeTimer   = null;
    this._imagesPending = 0;
  }

  connectedCallback() {
    this._swiperEl = this.querySelector('.cp-swiper');
    if (!this._swiperEl) return;

    this._handleResponsive();

    const images = Array.from(this.querySelectorAll('img'));
    this._imagesPending = images.filter(img => !img.complete).length;

    if (this._imagesPending === 0) {
      requestAnimationFrame(() => this._equalizeRows());
    } else {
      images.forEach(img => {
        if (!img.complete) {
          img.addEventListener('load',  this._onImageLoad, { once: true });
          img.addEventListener('error', this._onImageLoad, { once: true });
        }
      });
    }

    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
    clearTimeout(this._resizeTimer);
    this._destroySwiper();
  }

  _initSwiper() {
    if (this.swiper) return;
    this.swiper = new Swiper(this._swiperEl, {
      slidesPerView: 1.1,
      spaceBetween: 10,
      grabCursor: true,
      mousewheel: { forceToAxis: true },
      keyboard: { enabled: true, onlyInViewport: true },
      speed: 500,
    });
  }

  _destroySwiper() {
    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
    const wrapper = this._swiperEl.querySelector('.swiper-wrapper');
    if (wrapper) wrapper.style.transform = '';
  }

  _equalizeRows() {
    this.querySelectorAll('.cp-product__header').forEach(el => {
      el.style.minHeight = '';
    });

    this.querySelectorAll('.cp-attr').forEach(el => {
      el.style.minHeight = '';
    });

    const headers = Array.from(this.querySelectorAll('.cp-product__header'));
    if (headers.length) {
      const maxHeader = headers.reduce((acc, el) => {
        return Math.max(acc, el.getBoundingClientRect().height);
      }, 0);
      headers.forEach(el => {
        el.style.minHeight = maxHeader + 'px';
      });
    }

    const rowNames = [
      ...new Set(
        Array.from(this.querySelectorAll('[data-row]'))
          .map(el => el.dataset.row)
          .filter(Boolean)
      )
    ];

    rowNames.forEach(row => {
      const cells = Array.from(this.querySelectorAll(`[data-row="${row}"]`));
      if (!cells.length) return;

      const max = cells.reduce((acc, cell) => {
        return Math.max(acc, cell.getBoundingClientRect().height);
      }, 0);

      cells.forEach(cell => {
        cell.style.minHeight = max + 'px';
      });
    });
  }

  _handleResponsive() {
    const isMobile = window.innerWidth < this._BREAKPOINT;

    if (isMobile) {
      this._initSwiper();
    } else {
      this._destroySwiper();
    }

    requestAnimationFrame(() => this._equalizeRows());
  }

  _onResize() {
    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => this._handleResponsive(), 150);
  }

  _onImageLoad() {
    this._imagesPending--;
    if (this._imagesPending <= 0) {
      requestAnimationFrame(() => this._equalizeRows());
    }
  }
}

if (!customElements.get('productpage-compare-products-carousel')) {
  customElements.define(
    'productpage-compare-products-carousel',
    ProductpageCompareProductsCarousel
  );
}

class FaqAccordions extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelectorAll('details');
    
    this.details.forEach(detail => {
      detail.addEventListener('toggle', this._onToggle.bind(this));
    });
  }

  disconnectedCallback() {
    this.details.forEach(detail => {
      detail.removeEventListener('toggle', this._onToggle.bind(this));
    });
  }

  _onToggle(event) {
    const openedDetail = event.target;
    
    if (!openedDetail.open) return;

    this.details.forEach(detail => {
      if (detail !== openedDetail && detail.open) {
        detail.removeAttribute('open');
      }
    });
  }
}

customElements.define('faq-accordions', FaqAccordions);


class imageText5050Carousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        prevEl: this.querySelector(".swiper-nav-button--prev"),
        nextEl: this.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
    });
  }
}
customElements.define("image-text-50-50-carousel", imageText5050Carousel);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VideojsSimpleControl extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.video = this.querySelector("video-js");
    this.aspectRatio = this.dataset.aspectRatio;

    this.videojsPlayer = videojs(this.video, {
      aspectRatio: this.aspectRatio,
      fluid: true,
      responsive: true,
      inactivityTimeout: 0,
      bigPlayButton: false,
      controlBar: {
        volumePanel: false,
        muteToggle: true,
        subsCapsButton: false,
        progressControl: false,
        remainingTimeDisplay: false,
        pictureInPictureToggle: false,
        fullscreenToggle: false,
      },
    }).player();

    this.observer = new IntersectionObserver(
      function (entries) {
        if (entries[0]["isIntersecting"] === true) {
        } else {
          this.videojsPlayer.muted(true);
        }
      }.bind(this),
      { root: null, rootMargin: "0px", threshold: 0 },
    );

    this.observer.observe(this);
  }
}
customElements.define("video-js-simple-control", VideojsSimpleControl);

class VideojsFullControl extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.video = this.querySelector("video-js");
    this.aspectRatio = this.dataset.aspectRatio;

    this.videojsPlayer = videojs(this.video, {
      aspectRatio: this.aspectRatio,
      fluid: true,
      responsive: true,
      inactivityTimeout: 0,
      bigPlayButton: true,
      controlBar: {
        subsCapsButton: false,
        pictureInPictureToggle: false,
      },
    }).player();

    this.observer = new IntersectionObserver(
      function (entries) {
        if (entries[0]["isIntersecting"] === true) {
        } else {
          this.videojsPlayer.muted(true);
        }
      }.bind(this),
      { root: null, rootMargin: "0px", threshold: 0 },
    );

    this.observer.observe(this);
  }
}
customElements.define("video-js-full-control", VideojsFullControl);

class VideojsNoControl extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.video = this.querySelector("video-js");
    this.videojsPlayer = videojs(this.video, {
      aspectRatio: "1:1",
      fluid: true,
      responsive: true,
      inactivityTimeout: 0,
      bigPlayButton: false,
      controls: false,
    }).player();
  }
}
customElements.define("video-js-no-control", VideojsNoControl);

class NewsletterForm extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.ajaxFormInit(this.querySelector("form"));
  }

  formToJSON(elements) {
    return [].reduce.call(
      elements,
      function (data, element) {
        data[element.name] = element.value;
        return data;
      },
      {},
    );
  }

  // Get Shopify Friendly URL String
  getUrlString(data) {
    var urlParameters = Object.entries(data)
      .map(function (e) {
        return e.join("=");
      })
      .join("&");

    return urlParameters;
  }

  getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  }

  isEmail(email) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email,
    );
  }

  ajaxFormInit(form) {
    const action = form.getAttribute("action"),
      form_type = form.querySelector('[name="form_type"]').value,
      inputs = form.querySelectorAll("[name]"),
      emailInput = form.querySelector('input[name="contact[email]"]'),
      success_msg = form.querySelector(".form-message--success"),
      spam_msg = form.querySelector(".form-message--spam"),
      error_msg = form.querySelector(".form-message--error"),
      invalid_msg = form.querySelector(".form-message--invalid"),
      submit_btn = form.querySelector('button[type="submit"]');

    submit_btn.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        if (!this.isEmail(emailInput.value)) {
          invalid_msg.classList.add("active");
          invalid_msg.setAttribute("tabindex", "-1");
          invalid_msg.focus();
          setTimeout(() => {
            invalid_msg.removeAttribute("tabindex");
          }, 1000);
          return false;
        } else {
          invalid_msg.classList.remove("active");
          // form.submit();
        }

        if (window._rsq) {
          window._rsq.push(["_setUserEmail", emailInput.value]);
          window._rsq.push(["_setAction", "email_entered"]);
          window._rsq.push(["_track"]);
        }

        fetch(action, {
          method: "POST",
          body: this.getUrlString(this.formToJSON(inputs)),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            Accept: "text/html, */*; q=0.01",
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then(
            function (response) {
              if (response.status == 429) {
                spam_msg.classList.add("active");
                spam_msg.setAttribute("tabindex", "-1");
                spam_msg.focus();
                setTimeout(() => {
                  spam_msg.removeAttribute("tabindex");
                }, 1000);
              } else {
                success_msg.classList.add("active");
                success_msg.setAttribute("tabindex", "-1");
                success_msg.focus();
                setTimeout(() => {
                  success_msg.removeAttribute("tabindex");
                }, 1000);
              }
            }.bind(this),
          )
          .catch(function (err) {
            console.error(err);
            error_msg.classList.add("active");
          })
          .finally(function () {
            setTimeout(() => {
              success_msg.classList.remove("active");
              spam_msg.classList.remove("active");
              error_msg.classList.remove("active");
            }, 10000);
          });
      }.bind(this),
    );
  }
}
customElements.define("newsletter-form", NewsletterForm);
class BisForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.variantIdInput = this.form.querySelector(
      'input[name="bis_variant_id"]',
    );
    this.productIdInput = this.form.querySelector(
      'input[name="bis_product_id"]',
    );
    this.emailInput = this.form.querySelector('input[name="bis_email"]');
    ((this.success_msg = this.form.querySelector(".form-message--success")),
      (this.error_msg = this.form.querySelector(".form-message--error")),
      (this.registered_msg = this.form.querySelector(
        ".form-message--registered",
      )));
  }
  connectedCallback() {
    this.form.addEventListener(
      "submit",
      function (event) {
        event.preventDefault();
        const email = this.emailInput.value,
          productId = this.productIdInput.value,
          variantId = this.variantIdInput.value;
        BIS.create(email, variantId, productId).then((data) => {
          if (data.status == "OK") {
            this.success_msg.classList.add("active");
          } else if (
            data.status == "Error" &&
            data.errors.base &&
            this.registered_msg
          ) {
            this.registered_msg.classList.add("active");
          } else {
            this.error_msg.classList.add("active");
          }
          setTimeout(() => {
            this.success_msg.classList.remove("active");
            this.error_msg.classList.remove("active");
            if (this.registered_msg) {
              this.registered_msg.classList.remove("active");
            }
          }, 5000);
        });
      }.bind(this),
    );
  }
}
customElements.define("bis-form", BisForm);

class SelectRadio extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
    this.list = this.button.nextElementSibling;
    this.radios = this.list.querySelectorAll('input[type="radio"]');

    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.button.addEventListener("click", this.onToggle.bind(this));

    this.radios.forEach((radio) => {
      // radio.addEventListener("click", this.onRadioClick.bind(this));
      radio.addEventListener("change", this.onRadioChange.bind(this));
      radio.addEventListener("keydown", this.onRadioKeyDown.bind(this));
    });
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() == "ESCAPE") {
      this.close();
      this.button.focus();
    }
  }

  onToggle(event) {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  onRadioChange(event) {
    console.log("onRadioChange");
    const checkedRadio = this.getCheckedRadio();
    const labelContent = this.getRadioLabelContent(checkedRadio);
    this.updateButtonText(labelContent);

    if (event.clientX === 0 && event.clientY === 0) {
    } else {
      this.close();
    }
  }

  onRadioKeyDown(event) {
    if (
      event.code.toUpperCase() === "ENTER" ||
      event.code.toUpperCase() === "SPACE"
    ) {
      event.preventDefault();
      this.close();
      this.button.focus();
    }
  }

  getCheckedRadio() {
    return Array.from(this.radios).find((radio) => radio.checked);
  }

  getRadioLabelContent(radio) {
    return radio.nextElementSibling.innerHTML;
  }

  updateButtonText(text) {
    this.button.children[0].innerHTML = text;
  }

  isOpen() {
    return this.hasAttribute("open");
  }

  open(event) {
    this.setAttribute("open", true);
    this.button.setAttribute("aria-expanded", true);
    this.getCheckedRadio()?.focus();
  }

  close(event) {
    this.removeAttribute("open");
    this.button.setAttribute("aria-expanded", false);
  }
}
customElements.define("select-radio", SelectRadio);

class TabList extends HTMLElement {
  constructor() {
    super();

    this.tabButtons = this.querySelectorAll(".tab-button");
    this.tabPanels = this.querySelectorAll(".tab-panel");
    this.tabLinks = this.querySelectorAll(".tab-link");

    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", (e) => {
      const clickedTab = e.target.closest(".tab-button");
      if (!clickedTab) return;
      e.preventDefault();

      this.switchTab(clickedTab);
    });

    this.addEventListener("keydown", (e) => {
      switch (e.key) {
        case "ArrowLeft":
          this.moveLeft();
          break;
        case "ArrowRight":
          this.moveRight();
          break;
        case "Home":
          e.preventDefault();
          this.switchTab(tabButtons[0]);
          break;
        case "End":
          e.preventDefault();
          this.switchTab(tabButtons[tabButtons.length - 1]);
          break;
      }
    });
  }

  moveLeft() {
    const currentTab = document.activeElement;
    if (!currentTab.parentElement.previousElementSibling) {
      this.switchTab(tabButtons[tabButtons.length - 1]);
    } else {
      this.switchTab(
        currentTab.parentElement.previousElementSibling.querySelector("a"),
      );
    }
  }

  moveRight() {
    const currentTab = document.activeElement;
    if (!currentTab.parentElement.nextElementSibling) {
      this.switchTab(tabButtons[0]);
    } else {
      this.switchTab(
        currentTab.parentElement.nextElementSibling.querySelector("a"),
      );
    }
  }

  switchTab(newTab) {
    const activePanelId = newTab.dataset.panelId;
    const activePanel = this.querySelector(activePanelId);

    const activeLInkId = newTab.dataset.linkId;
    const activeLInk = this.querySelector(activeLInkId);

    this.tabButtons.forEach((button) => {
      button.setAttribute("aria-selected", false);
      button.setAttribute("tabindex", "-1");
    });

    this.tabPanels.forEach((panel) => {
      panel.classList.add("hidden");
    });

    this.tabLinks.forEach((link) => {
      link.classList.add("hidden");
    });

    activePanel.classList.remove("hidden");
    activeLInk.classList.remove("hidden");

    newTab.setAttribute("aria-selected", true);
    newTab.setAttribute("tabindex", "0");
    newTab.focus();
  }
}
customElements.define("tab-list", TabList);

class CartSample extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".swiper");
  }
  connectedCallback() {
    this.swiper = new Swiper(this.carousel, {
      grabCursor: true,
      slidesPerView: 3.5,
      spaceBetween: 10,
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
      centerInsufficientSlides: false,
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: true,
        sticky: false,
      },
      navigation: {
        prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
        nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
        992: {
          slidesPerView: 3.5,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
        1200: {
          slidesPerView: 4.5,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
      },
    });
  }
}
customElements.define("cart-sample", CartSample);

class CartUpsell extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".swiper");
  }
  connectedCallback() {
    this.swiper = new Swiper(this.carousel, {
      grabCursor: true,
      slidesPerView: 1.6,
      spaceBetween: 10,
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
      centerInsufficientSlides: false,
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: true,
        sticky: false,
      },
      navigation: {
        prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
        nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      breakpoints: {
        768: {
          slidesPerView: 1.6,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
        992: {
          slidesPerView: 1.6,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
        1200: {
          slidesPerView: 1.6,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
      },
    });
  }
}
customElements.define("cart-upsell", CartUpsell);

class CartDrawerUpsell extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".swiper");

    this.close = this.querySelector(".cart-drawer-upsell-close");

    this.close.addEventListener("click", this.onCloseClicked.bind(this));
  }

  onCloseClicked() {
    this.remove();
  }

  connectedCallback() {
    this.swiper = new Swiper(this.carousel, {
      grabCursor: true,
      slidesPerView: 1.6,
      spaceBetween: 10,
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
      centerInsufficientSlides: false,
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: true,
        sticky: false,
      },
      navigation: {
        prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
        nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      breakpoints: {
        768: {
          slidesPerView: 1.6,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24,
        },
        992: {
          slidesPerView: 1.6,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24,
        },
        1200: {
          slidesPerView: 1.6,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24,
        },
      },
    });
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);

// Multiple variants
class MultipleVariantsRadio extends HTMLElement {
  constructor() {
    super();

    this.variants = this.querySelectorAll("button.variant-radio");
    this.button = this.querySelector("button.variant-selector-mobile");
    this.list = this.button.nextElementSibling;

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.closest(".swiper")) {
      this.addEventListener("focusout", this.onFocusOut.bind(this));
    }
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.button.addEventListener("click", this.onToggle.bind(this));

    this.variants.forEach((variant) => {
      variant.addEventListener("click", this.onVariantClick.bind(this));
    });

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
  onFocusOut(event) {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() == "ESCAPE") {
      this.close();
      this.button.focus();
    }
  }

  onToggle(event) {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  onRadioKeyDown(event) {
    if (
      event.code.toUpperCase() === "ENTER" ||
      event.code.toUpperCase() === "SPACE"
    ) {
      event.preventDefault();
      this.close();
      this.button.focus();
    }
  }

  isOpen() {
    return this.hasAttribute("open");
  }

  open(event) {
    document.querySelectorAll("multiple-variants-radio").forEach((variant) => {
      variant.removeAttribute("open");
      variant.button.setAttribute("aria-expanded", false);
    });
    this.setAttribute("open", true);
    this.button.setAttribute("aria-expanded", true);
    this.closest("product-card").classList.remove("isolate");
    if (this.closest(".swiper")) {
      // this.closest('.swiper').style.paddingBottom = `10rem`;
    }
  }

  close(event) {
    this.removeAttribute("open");
    this.button.setAttribute("aria-expanded", false);
    this.closest("product-card").classList.add("isolate");
    if (this.closest(".swiper")) {
      this.closest(".swiper").style.paddingBottom = `2.3rem`;
    }
  }

  onVariantClick(event) {
    const variant = event.currentTarget;
    const variantId = variant.getAttribute("data-id");
    const variantUrl = variant.getAttribute("data-url");
    const variantImage = variant.getAttribute("data-image");
    const variantImageHover = variant.getAttribute("data-image-hover");
    const variantPrice = variant.getAttribute("data-price");
    const variantAvailable = variant.getAttribute("data-available");
    const variantNotifyMe = variant.getAttribute("data-notify-me");
    const variantMeasurement = variant.getAttribute("data-measurement");
    const variantUnitPrice = variant.getAttribute("data-unit-price");
    this.variants.forEach((variant) => {
      variant.classList.remove("active");
      variant.setAttribute("aria-pressed", "false");
    });
    variant.classList.add("active");
    variant.setAttribute("aria-pressed", "true");
    this.button.querySelector(".variant-label").textContent =
      variant.textContent;
    this.close();

    variant.closest(".product-card").querySelector(".price-value").textContent =
      variantPrice;
    variantMeasurement
      ? (variant
          .closest(".product-card")
          .querySelector(".product-card-measurement").textContent =
          variantMeasurement)
      : null;
    variant
      .closest(".product-card")
      .querySelectorAll(".main-product-link")
      .forEach((link) => {
        link.setAttribute("href", variantUrl);
      });

    if (variantImage) {
      variant
        .closest(".product-card")
        .querySelector(".first-image")
        .setAttribute("src", variantImage);
      variant
        .closest(".product-card")
        .querySelector(".first-image")
        .setAttribute("srcset", variantImage);
    }
    console.log(variantImageHover);
    if (variantImageHover != null) {
      variant
        .closest(".product-card")
        .querySelector(".image-on-hover")
        .setAttribute("src", variantImageHover);
      variant
        .closest(".product-card")
        .querySelector(".image-on-hover")
        .setAttribute("srcset", variantImageHover);
      variant
        .closest(".product-card")
        .querySelector(".first-image")
        .classList.remove("toggle-disabled");
    } else {
      variant
        .closest(".product-card")
        .querySelector(".first-image")
        .classList.add("toggle-disabled");
    }

    if (variantUnitPrice != null) {
      variant
        .closest(".product-card")
        .querySelector(".pryce-item--unit .hidden≤1024").textContent =
        variantUnitPrice;
      variant
        .closest(".product-card")
        .querySelector(".pryce-item--unit .hidden≥1025").textContent =
        "(" + variantUnitPrice + ")";
    }

    variant
      .closest(".product-card")
      .querySelectorAll("product-form")
      .forEach((form) => {
        form.querySelector('input[name="id"]').setAttribute("value", variantId);
        if (variantNotifyMe) {
          form.querySelector(".quick-add__submit").classList.add("hidden");
          form.querySelector(".notify-me-btn").classList.remove("hidden");
          form.querySelector(".notify-me-btn").setAttribute("href", variantUrl);
        } else {
          form.querySelector(".quick-add__submit").classList.remove("hidden");
          form.querySelector(".notify-me-btn").classList.add("hidden");
        }
      });
  }
}
customElements.define("multiple-variants-radio", MultipleVariantsRadio);
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.comingSoonContainer = this.querySelector(".coming-soon-block");
    this.days = this.querySelector(".days");
    this.hours = this.querySelector(".hours");
    this.minutes = this.querySelector(".minutes");
    this.seconds = this.querySelector(".seconds");
  }

  connectedCallback() {
    const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;
    const dateDefault = this.dataset.timer;
    const timer = new Date(dateDefault.replace(" ", "T")).getTime();
    const changeTimeZone = (date, timeZone) => {
      if (typeof date === "string") {
        return new Date(
          new Date(date).toLocaleString("en-US", {
            timeZone,
          }),
        );
      }
      return new Date(
        date.toLocaleString("en-US", {
          timeZone,
        }),
      );
    };
    let x = setInterval(() => {
      let now = changeTimeZone(new Date(), "America/New_York").getTime();
      let distance = timer - now;
      if (distance > 0) {
        let daysLeft = Math.floor(distance / day);
        let hoursLeft = Math.floor((distance % day) / hour);
        let minutesLeft = Math.floor((distance % hour) / minute);
        let secondsLeft = Math.floor((distance % minute) / second);

        // Add leading zeros if units are less than 10
        daysLeft = daysLeft < 10 ? "0" + daysLeft : daysLeft;
        hoursLeft = hoursLeft < 10 ? "0" + hoursLeft : hoursLeft;
        minutesLeft = minutesLeft < 10 ? "0" + minutesLeft : minutesLeft;
        secondsLeft = secondsLeft < 10 ? "0" + secondsLeft : secondsLeft;

        this.days.innerText = daysLeft;
        this.hours.innerText = hoursLeft;
        this.minutes.innerText = minutesLeft;
        this.seconds.innerText = secondsLeft;

        let daysText =
          daysLeft == 1
            ? this.querySelector(".daysText").dataset.label
            : this.querySelector(".daysText").dataset.labels;
        let hoursText =
          hoursLeft == 1
            ? this.querySelector(".hoursText").dataset.label
            : this.querySelector(".hoursText").dataset.labels;
        let minutesText =
          minutesLeft == 1
            ? this.querySelector(".minutesText").dataset.label
            : this.querySelector(".minutesText").dataset.labels;
        let secondsText =
          secondsLeft == 1
            ? this.querySelector(".secondsText").dataset.label
            : this.querySelector(".secondsText").dataset.labels;

        this.querySelector(".daysText").innerText = daysText;
        this.querySelector(".hoursText").innerText = hoursText;
        this.querySelector(".minutesText").innerText = minutesText;
        this.querySelector(".secondsText").innerText = secondsText;

        if (
          daysLeft <= 0 &&
          hoursLeft <= 0 &&
          minutesLeft <= 0 &&
          secondsLeft <= 0
        ) {
          clearInterval(x);
          this.comingSoonContainer
            .closest("countdown-timer")
            .classList.add("hidden");
        }
      } else {
        this.comingSoonContainer
          .closest("countdown-timer")
          .classList.add("hidden");
      }
    }, second);
  }
}

customElements.define("countdown-timer", CountdownTimer);

/* --------------------------------------------------------------------------
   YouTube + OneTrust consent helpers

   YouTube is categorised as C0004 (Targeting Cookies) in OneTrust. When a
   visitor declines that category, OneTrust neutralises www-widgetapi.js -
   the file that actually defines YT.Player. The result is a half-loaded API:
   window.YT exists (created by iframe_api) but YT.Player does not. So a plain
   `if (window.YT)` check PASSES and `new YT.Player()` still throws
   "YT.Player is not a constructor". Always test for YT.Player itself.

   Note: iframe_api and www-widgetapi.js are always served from youtube.com.
   youtube-nocookie.com only changes the domain of the video frame, so it does
   not cover these two files.
-------------------------------------------------------------------------- */

// C0004 = Targeting Cookies. If OneTrust is not on this store, do not block.
function oribeYtConsentGranted() {
  if (typeof window.OnetrustActiveGroups === "undefined") return true;
  return (window.OnetrustActiveGroups || "").indexOf(",C0004,") !== -1;
}

function oribeOpenCookieSettings() {
  if (window.OneTrust && typeof OneTrust.ToggleInfoDisplay === "function") {
    OneTrust.ToggleInfoDisplay();
  }
}

// Loads the YouTube IFrame API once. Resolves only when YT.Player really exists.
function oribeLoadYouTubeApi() {
  return new Promise(function (resolve, reject) {
    if (window.YT && typeof window.YT.Player === "function") return resolve();

    if (!document.getElementById("yt-api-script")) {
      var tag = document.createElement("script");
      tag.id = "yt-api-script";
      tag.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(tag);
    }

    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (prev) prev();
      resolve();
    };

    // If OneTrust blocked the API the callback never fires, so time out.
    setTimeout(function () {
      if (window.YT && typeof window.YT.Player === "function") {
        resolve();
      } else {
        reject(new Error("YouTube IFrame API unavailable (blocked by consent)"));
      }
    }, 8000);
  });
}

class VideoModal extends HTMLElement {
  constructor() {
    super();
    const modalId = this.id;
    this.iframe = this.querySelector(".video-iframe");
    this.closeButton = this.querySelector(".close-video-modal");
    // this.playPauseButton = this.querySelector('.play-pause-button');
    this.player = null;

    this.consentNotice = this.querySelector("[data-video-consent-notice]");
    this.consentButton = this.querySelector("[data-video-consent-button]");
    this.pendingVideoId = null;
    this.pendingModalId = null;

    this.shoppableProducts = this.querySelectorAll(".shoppable-product");
    this.addToBagButtons = this.querySelectorAll(".quick-add__submit");

    this.addAllToBagBtn = this.querySelector(".add-all-to-bag-btn");

    this.cart = document.querySelector("cart-drawer");

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleConsentChange = this.handleConsentChange.bind(this);
  }

  connectedCallback() {
    const modalId = this.id;
    const openButtons = document.querySelectorAll(
      `[data-modal-id="${modalId}"]`,
    );
    openButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const videoId = button.dataset.videoId;
        this.open(videoId, modalId);
      });
    });

    this.shoppableProducts.forEach((product) => {
      if (product) {
        product.addEventListener("mouseenter", (e) =>
          this.handleShoppableHover(product),
        );
        product.addEventListener("mouseleave", (e) =>
          this.handleShoppableLeave(product),
        );
        const timestampEl = product.querySelector(".timestamp");
        if (timestampEl) {
          timestampEl.addEventListener("click", (e) =>
            this.handleShoppableClick(e, product),
          );
        }
      }
    });

    if (this.addAllToBagBtn) {
      this.addAllToBagBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.addAllShoppableProductsToCart();
      });
    }

    this.addToBagButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        setTimeout(() => {
          this.close();
        }, 1000);
      });
    });

    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => {
        this.close();
      });
    }

    if (this.consentButton) {
      this.consentButton.addEventListener("click", oribeOpenCookieSettings);
    }

    // If the visitor accepts targeting cookies while the modal is open,
    // build the player straight away instead of making them reload.
    window.addEventListener("OneTrustGroupsUpdated", this.handleConsentChange);
  }

  handleConsentChange() {
    if (this.classList.contains("hidden")) return;
    if (this.player || !this.pendingVideoId) return;
    if (!oribeYtConsentGranted()) return;
    this.buildPlayer(this.pendingVideoId, this.pendingModalId);
  }

  open(videoId, modalId) {
    this.classList.remove("hidden");

    this.pendingVideoId = videoId;
    this.pendingModalId = modalId;

    if (oribeYtConsentGranted()) {
      this.buildPlayer(videoId, modalId);
    } else {
      this.showConsentNotice();
    }

    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeyDown);
      document.addEventListener("click", this.handleOutsideClick);
    }, 10);

    if (this.closeButton) {
      this.closeButton.focus();
    }

    // Prevent body scroll when video modal is open
    document.querySelector("body").classList.add("overflow-hidden");

    window.addEventListener(
      "focus",
      () => {
        setTimeout(() => {
          document.activeElement.blur();
          if (this.closeButton) {
            this.closeButton.focus();
          }
        }, 500);
      },
      { once: true },
    );
  }

  buildPlayer(videoId, modalId) {
    const mount = document.getElementById(`player-${modalId}`);
    if (!mount) return;

    // Player already exists - just swap the video.
    if (this.player && typeof this.player.loadVideoById === "function") {
      this.hideConsentNotice();
      this.player.loadVideoById(videoId);
      return;
    }

    oribeLoadYouTubeApi()
      .then(() => {
        this.hideConsentNotice();
        this.player = new YT.Player(`player-${modalId}`, {
          host: "https://www.youtube-nocookie.com",
          height: "100%",
          width: "100%",
          videoId: videoId,
          playerVars: {
            autoplay: 1,
            loop: 1,
            modestBranding: 0,
            controls: 1,
            rel: 0,
            showInfo: 1,
          },
          events: {
            onReady: this.onPlayerReady.bind(this),
            onStateChange: this.onPlayerStateChange.bind(this),
          },
        });
      })
      .catch(() => {
        // API blocked by consent - show the notice instead of an empty box.
        this.showConsentNotice();
      });
  }

  showConsentNotice() {
    // The notice can be switched off per store in Theme settings > Onetrust,
    // in which case it is not rendered at all - leave the player mount in
    // place rather than hiding it and leaving a blank modal behind.
    if (!this.consentNotice) return;
    const mount = document.getElementById(`player-${this.pendingModalId}`);
    if (mount) mount.classList.add("hidden");
    this.consentNotice.classList.remove("hidden");
  }

  hideConsentNotice() {
    const mount = document.getElementById(`player-${this.pendingModalId}`);
    if (mount) mount.classList.remove("hidden");
    if (this.consentNotice) this.consentNotice.classList.add("hidden");
  }

  close() {
    this.classList.add("hidden");
    document.querySelector("body").classList.remove("overflow-hidden");
    if (this.player && typeof this.player.pauseVideo === "function") {
      this.player.pauseVideo();
    }

    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("click", this.handleOutsideClick);
  }

  handleKeyDown(e) {
    if (e.key === "Escape" || e.key === "Esc") {
      this.close();
    }
  }

  handleOutsideClick(e) {
    const videoContainer = this.querySelector(".video-modal-content");
    if (!videoContainer.contains(e.target) && window.innerWidth >= 768) {
      this.close();
    }
  }

  onPlayerReady(event) {
    const player = event.target;
    player.setVolume(100);
    player.playVideo();

    // if (this.playPauseButton) {
    //   this.playPauseButton.addEventListener('click', () => {
    //     const state = player.getPlayerState();

    //     if (state === YT.PlayerState.PLAYING) {
    //       player.pauseVideo();
    //       this.classList.add('paused');
    //     } else if (state === YT.PlayerState.PAUSED || state === YT.PlayerState.UNSTARTED) {
    //       player.playVideo();
    //       this.classList.remove('paused');
    //     }
    //   });
    // }
  }

  onPlayerStateChange(event) {
    const player = event.target;
    const state = event.data;

    if (state === YT.PlayerState.PLAYING) {
      this.classList.remove("paused");
    } else if (state === YT.PlayerState.PAUSED) {
      this.classList.add("paused");
    } else if (state === YT.PlayerState.ENDED) {
      player.seekTo(0);
      player.playVideo();
    }
  }

  handleShoppableHover(hoveredProduct) {
    if (this.dataset.style == "short") return;

    this.shoppableProducts.forEach((product) => {
      if (product !== hoveredProduct) {
        product.removeAttribute("open");
      }
    });

    hoveredProduct.setAttribute("open", "");
  }

  handleShoppableLeave(hoveredProduct) {
    hoveredProduct.removeAttribute("open");
  }

  handleShoppableClick(e, clickedProduct) {
    const timestamp = parseInt(
      clickedProduct.getAttribute("data-timestamp"),
      10,
    );
    if (this.player && !isNaN(timestamp)) {
      this.seekToTimestamp(timestamp);
    }
  }

  seekToTimestamp(timestamp) {
    this.player.seekTo(timestamp, true);
  }

  addAllShoppableProductsToCart() {
    const items = Array.from(this.shoppableProducts)
      .filter((product) => product.dataset.available === "true")
      .map((product) => ({
        id: product.dataset.id,
        quantity: 1,
      }));

    this.addShoppableProductsToCart(items);
    setTimeout(() => {
      this.close();
    }, 1000);
  }

  addShoppableProductsToCart(items) {
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    const updatedSections = this.cart
      .getSectionsToRender()
      .map((section) => section.section);

    const addFormData = {
      items: items,
      sections: updatedSections,
      sections_url: window.location.pathname,
    };

    config.body = JSON.stringify(addFormData);

    return fetch(`${routes.cart_add_url}`, config)
      .then((res) => res.json())
      .then((response) => {
        if (window.gwp.isGWPAvailable()) {
          return window.gwp.getGWPCart().then((cart) => {
            if (
              !window.gwp.isGWPItemInCart(cart) &&
              cart.item_count <= items.length
            ) {
              return window.gwp.addGWPToCart(
                this.cart
                  .getSectionsToRender()
                  .map((section) => section.section),
              );
            } else {
              return response;
            }
          });
        } else {
          return response;
        }
      })
      .then((response) => {
        this.cart.renderContents(response);
      })
      .catch((err) => {
        console.error("Error adding items to cart:", err);
      });
  }
}

customElements.define("video-modal", VideoModal);


class HomepageShoppableVideo extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.player = null;
    this.playerReady = false;
    this.consentListenerAdded = false;
  }

  connectedCallback() {
    this.initYouTubeAPI();
    this.initSwiper();
    this.initAddAllBtn();
  }

  initYouTubeAPI() {
    // The embed itself is a youtube-nocookie.com iframe rendered in Liquid and
    // it keeps autoplaying on its own. Only the JS API is consent-gated, so
    // without C0004 we simply skip it - the video still plays, we just lose
    // programmatic control. Nothing is broken and no error is thrown.
    if (!oribeYtConsentGranted()) {
      if (!this.consentListenerAdded) {
        this.consentListenerAdded = true;
        window.addEventListener("OneTrustGroupsUpdated", () => {
          if (!this.player && oribeYtConsentGranted()) this.initYouTubeAPI();
        });
      }
      return;
    }

    const iframeId = `shoppable-video-iframe-${this.sectionId}`;
    if (!document.getElementById(iframeId)) return;

    oribeLoadYouTubeApi()
      .then(() => {
        this.player = new YT.Player(iframeId, {
          events: {
            onReady: () => {
              this.playerReady = true;
              // Start muted autoplay
              this.player.mute();
              this.player.playVideo();
            },
          },
        });
      })
      .catch(() => {
        // API unavailable - the iframe carries on playing by itself.
      });
  }

  initSwiper() {
    const swiperEl = this.querySelector(`#shoppable-video-${this.sectionId} .shoppable-video-products-swiper`);
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const productsPerView = Number(swiperEl.dataset.productsPerView) || 2.2;
    
    if (window.innerWidth < 992) {
      this.productSwiper = new Swiper(swiperEl, {
        slidesPerView: productsPerView,
        slidesPerGroup: 1,
        spaceBetween: 2,
        loop: false,
        rewind: true,
        speed: 300,
        allowTouchMove: true,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
          thresholdDelta: 10,
          thresholdTime: 500,
          releaseOnEdges: true,
        }
      });
    }
  }

  initAddAllBtn() {
    const btn = this.querySelector(`#shoppable-video-${this.sectionId} .shoppable-video-add-all-btn`);
    if (!btn) return;

    btn.dataset.originalLabel = btn.textContent.trim();

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      this.addAllToCart(btn);
    });
  }

  addAllToCart(btn) {
    const items = Array.from(this.querySelectorAll(`#shoppable-video-${this.sectionId} .shoppable-video-product[data-available="true"]`))
      .map((p) => ({
        id: p.dataset.variantId,
        quantity: 1,
      }));

    if (!items.length) return;

    btn.disabled = true;

    this.addToCart(items)
      .then(() => {
        // btn.textContent = '✓ Added';
        setTimeout(() => {
          btn.textContent = btn.dataset.originalLabel;
          btn.disabled = false;
        }, 2000);
      })
      .catch((err) => {
        console.error('Add all to bag failed:', err);
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      });
  }

  addToCart(items) {
    const cart = document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const updatedSections = cart
      ? cart.getSectionsToRender().map((section) => section.section)
      : [];

    const body = {
      items,
      sections: updatedSections,
      sections_url: window.location.pathname,
    };

    config.body = JSON.stringify(body);

    return fetch(routes.cart_add_url, config)
      .then((res) => res.json())
      .then((response) => {
        if (window.gwp && window.gwp.isGWPAvailable()) {
          return window.gwp.getGWPCart().then((cartData) => {
            if (
              !window.gwp.isGWPItemInCart(cartData) &&
              cartData.item_count <= items.length
            ) {
              return window.gwp.addGWPToCart(updatedSections);
            }
            return response;
          });
        }
        return response;
      })
      .then((response) => {
        if (cart) cart.renderContents(response);
      });
  }
}

customElements.define('hp-shoppable-video', HomepageShoppableVideo);


class iconsSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const parentId = this.parentElement.id;
    const prevButton = document.querySelector(
      `[data-controls='${parentId}'] .slider-control-prev`,
    );
    const nextButton = document.querySelector(
      `[data-controls='${parentId}'] .slider-control-next`,
    );

    this.swiper = new Swiper(this, {
      slidesPerView: 2.6,
      spaceBetween: 10,
      slidesOffsetBefore: 12,
      freeMode: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        390: {
          slidesPerView: 3.4,
        },
        500: {
          slidesPerView: 4.4,
        },
        768: {
          slidesPerView: 5.4,
        },
      },
    });
  }
}
customElements.define("icons-slider", iconsSlider);

class articleCarousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.swiper = new Swiper(this, {
      grabCursor: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      centerInsufficientSlides: false,
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: true,
        sticky: false,
      },
      navigation: {
        prevEl: this.querySelector(".swiper-nav-button--prev"),
        nextEl: this.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      768: {
        slidesPerView: 5,
      },
    });
  }
}
customElements.define("article-carousel", articleCarousel);
